// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3loTl","footer":"ReportModalFilter_footer__wVKnl"};